<template>
  <v-snackbar v-model="snackVisible" :timeout="snackTime" >
    {{snackText}}
    <!-- <v-btn text color="primary" @click.native="value = false">Close</v-btn> -->
  </v-snackbar>
</template>

<script>
  export default {
    name: 'cardLoading',
    props: {
      snackP: {
        type: Boolean,
        default: () => false
      },
      snackText: {
        type: String,
        default: () => 'texto'
      },
      snackTime: {
        type: Number,
        default: () => 3000
      },
    },
    emits: ['update:snackP'],
    computed: {
      snackVisible: {
        get() {
          return this.snackP
        },
        set(value) {
          this.$emit('update:snackP', value)
        }
      }
    },
    data() {
      return {
        snack: true
      }
    },
  }
</script>

<style scoped>


</style>